import {
  useHelmet,
  TitleTag,
  MetaTag,
  LinkTag
} from '@thd-nucleus/thd-helmet';
import PropTypes from 'prop-types';
import { useLocation, useParams } from '@thd-olt-component-react/router';

const colorWallHandler = ({ props }) => {
  const {
    pathname,
    data,
    routeColor,
    brand
  } = props;
  const { colorWallData } = data || {};
  const { colorFamily } = colorWallData || {};

  const type = 'Category';
  const formatColorFamily = (colorFamily || routeColor)
    ? (colorFamily || routeColor).charAt(0).toUpperCase() + (colorFamily || routeColor).slice(1)
    : 'Popular';
  const title = `${formatColorFamily} Paint Colors ${brand ? `from ${brand} ` : ''}- The Home Depot`;
  const canonical = `https://www.homedepot.com${pathname}`;
  const tags = [
    new TitleTag(title),
    new LinkTag({ rel: 'canonical', href: canonical, id: 'canonical' }),
    new MetaTag({ property: 'og:title', content: title, id: 'ogTitle' }),
    new MetaTag({ property: 'og:url', content: canonical, id: 'ogUrl' }),
    new MetaTag({ property: 'og:type', content: type, id: 'ogType' }),
    new MetaTag({ property: 'og:site_name', content: 'The Home Depot', id: 'ogSiteName' }),
    new MetaTag({ property: 'fb:admins', content: '100005416960152', id: 'fbAdmins' })
  ];

  return tags;
};

const ColorWallMetadata = ({ data } = {}) => {
  const {
    pathname,
    search
  } = useLocation() || {};
  const { color, brand: routeBrand } = useParams() || {};

  const decodedRouteBrand = routeBrand ? decodeURI(routeBrand) : null;
  const rawBrandName = new URLSearchParams(search || '').get('brand');
  const brand = data?.brand || decodedRouteBrand || rawBrandName || null;

  useHelmet('colorWall', {
    props: {
      data,
      routeColor: color,
      brand,
      pathname
    },
    skipCleanup: true
  }, colorWallHandler);
  return null;
};

ColorWallMetadata.displayName = 'ColorWallMetadata';

ColorWallMetadata.propTypes = {
  data: PropTypes.shape({
    brand: PropTypes.string,
    colorWallData: PropTypes.shape({
      colorFamily: PropTypes.string,
      colorWallData: PropTypes.shape({
        dimensions: PropTypes.arrayOf(PropTypes.shape({
          refinements: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string,
            selected: PropTypes.oneOfType([
              PropTypes.bool,
              PropTypes.oneOf([null])
            ])
          }))
        }))
      })
    })
  })
};

export { ColorWallMetadata };